export const AUTO_RUN = '@@javascript/AUTO_RUN';

export function setAutoRun(value) {
  return { type: AUTO_RUN, value };
}



// WEBPACK FOOTER //
// ./src/actions/javascript.js